export default __webpack_public_path__ + "static/media/banner_96x36in.4d2733b5.png";